import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import router from 'router';
import { ThemeProvider } from '@mui/material';
import { appTheme } from 'theme/base';
import './App.scss';
import './i18n';

const App: FC = () => {
  const content = useRoutes(router);

  return (
    <ThemeProvider theme={appTheme}>
      <div className="app">{content}</div>
    </ThemeProvider>
  );
};

export default App;
